export default __webpack_public_path__ + "static/media/tschelogo.907d769b.png";